module.exports = __webpack_public_path__ + "static/media/realtime-regular.caaae82c.woff2";